import {createTheme, responsiveFontSizes} from '@mui/material'

export const theme = createTheme({
    typography: {
        button: {
            textTransform: 'none',
        },
        fontFamily: "'Poppins', sans-serif",
    },

    palette: {
        mode: 'light',
        primary: {
            main: '#8843B5',
            light: '#A869D5',
            dark: '#662D8A',
            100: '#F2E6F8',
            200: '#E5CCF1',
            300: '#D8B3EA',
            400: '#CB99E3',
            500: '#8843B5',
            600: '#7A3BA3',
            700: '#6B3390',
            800: '#5D2C7E',
            900: '#4E246B',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#2A458A',
            dark: '#303287',
            light: '#5B5CC4',
            100: '#F0F0FA',
            200: '#CACBEC',
            300: '#A5A6DF',
            400: '#8081D0',
            800: '#1F2056',
            // 900: '#15163B',
            900: '#17173b',
        },
        error: {
            main: '#E9132D',
            dark: '#A91123',
            light: '#F9C4CB',
        },
        success: {
            main: '#A4CE3C',
            dark: '#197942',
            light: '#DBFDD7',
        },
        warning: {
            main: '#F5C30F',
            dark: '#EE843F',
            light: '#FDF1C3',
        },
        info: {
            main: '#5B99FF',
            dark: '#3F70C1',
            light: '#D6E4FF',
            900: '#393CA2',
        },
        text: {
            primary: '#2A458A',
            secondary: '#FFFFFF',
            disabled: '#999999',
        },
        background: {
            default: '#FFFFFF',
            paper: '#ffffff',
        },
        grey: {
            50: '#EDEDED',
            100: '#ECEFF6',
            200: '#E9ECEF',
            300: '#B3B3B3',
            500: '#9098A9',
            600: '#666666',
            700: '#4D4D4D',
            800: '#333333',
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    // Firefox
                    scrollbarColor: '#8843B5 transparent',
                    // WebKit-based browsers
                    '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
                        width: 4,
                        height: 4,
                    },
                    '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
                        backgroundColor: '#8843B5',
                        borderRadius: 8,
                    },
                    '&::-webkit-scrollbar-track, & *::-webkit-scrollbar-track': {
                        background: 'transparent',
                    },
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                size: 'small',
                variant: 'outlined',
                inputProps: {
                    autoComplete: 'off',
                },
            },
        },
        MuiTypography: {
            defaultProps: {
                variant: 'body2',
            },
        },
        MuiMenu: {
            defaultProps: {
                elevation: 0,
                transformOrigin: { horizontal: 'right', vertical: 'top' },
                anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            },
        },

        MuiButton: {
            defaultProps: {
                size: 'small',
            },
        },

        MuiCheckbox: {
            defaultProps: {
                color: 'secondary',
                size: 'small',
            },
            styleOverrides: {
                root: ({ theme }) => ({
                    color: theme.palette.grey[300],
                }),
                checked: ({ theme }) => ({
                    background: theme.palette.grey[300],
                }),
            },
        },

        MuiRadio: {
            defaultProps: {
                color: 'secondary',
                size: 'small',
            },
            styleOverrides: {
                root: ({ theme }) => ({
                    color: theme.palette.grey[300],
                }),
                checked: ({ theme }) => ({
                    background: theme.palette.grey[300],
                }),
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: ({ theme }) => ({
                    color: theme.palette.secondary.dark,
                    fontSize: 14,
                    fontWeight: 500,
                }),
            },
        },
    },
});
export default responsiveFontSizes(theme)
